<template>
    <div class="blackBg animated slideInLeft">
        <div class="cardTit">
            <span class="season">{{$store.state.seasonName}}</span>
            <span class="teamName">{{teamName?teamName:'XXX'}}</span>
            <p class="dateGame">
                <span class="month">{{$global.formatDate(new Date(),'MM',true)}}月</span>
                <span class="gameNum">本月比赛数 <span>{{scheduleList.length}}</span> <i>场</i></span>
            </p>
        </div>
        <div class="scheduleList">
            <div class="scheduleItem" v-for="item in scheduleList">
                <p class="gameTitle">
                    <span class="YouSheBiaoTiHei matchType" :class="item.matchType=='regularGame'?'true':'false'">{{item.matchType=='regularGame'?'正规赛':'训练赛'}}</span>
                    <span class="regular date">{{item.date}}</span>
                    <span  class="regular date">{{item.start}}</span>
                    <span class="address">{{item.pitch}}</span>
                </p>
                <div class="cardBg">
                    <p class="leftImg imgBox">
                        <img :src="configJson.CONFIG[baseUrl.DOMAIN_URL].scheduleIcon1" alt="">
                        <span class="PingFang">{{teamName}}</span>
                    </p>
                    <div class="middle">
                        <p class="vsTit">{{item.score ? item.score.split(':')[0] + '-' + item.score.split(':')[1] : 'VS'}}</p>
                    </div>
                    <p class="rightImg imgBox">
                        <img :src="configJson.CONFIG[baseUrl.DOMAIN_URL].scheduleIcon2" alt="">
                        <span class="PingFang">{{item.against}}</span>
                    </p>
                </div>
                <div style="clear: both"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "schedule",
        computed:{
            teamId() {
                return this.$store.state.teamId;
            }
        },
        data() {
            return {
                teamName: this.$store.state.teamName.split('_')[0],//梯队名称
                scheduleList:[],//赛程
            }
        },
        watch:{
            teamId:{
                handler(val,old){
                    if(val!=old){
                        this.teamName = this.$store.state.teamName.split('_')[0];//梯队名称
                        this.info()
                    }
                },
                deep:true
            }
        },
        mounted() {
            this.info();
        },
        methods:{
            info(){
                let data={
                    teamId:this.teamId,
                    type: 'matches'
                    // teamId:'0a8f5530-53ba-408e-b014-6c8874abcdca',
                }
                this.scheduleFn(data);
            },
            //赛程list
            scheduleFn(data){
                this.$server.schedule(data)
                    .then((res)=>{
                        this.scheduleList= res.data
                        console.log(this.scheduleList)
                    })
            },
        }
    }
</script>

<style scoped lang="less">
    .cardTit{
        background-image: url("../assets/img/updateImg/head_2.png");
        margin-bottom: 10px;
        font-size: 30px;
        box-sizing: border-box;
        position: relative;
        .season,.dateGame{
            font-family: PingFangMedium;
            color: #fff;
            display: inline-block;
            line-height: 120px;
            position: absolute;
        }
        .season{
            line-height: 130px;
            left: 2vw;
        }
        .dateGame{
            right: 2vw;
            .month{
                margin-right: 2vw;
            }
            .gameNum{
                span{
                    color: #ACA1FF;
                    font-size: 48px;
                    font-family: akrobatBold;
                }
                i{
                    color: #ACA1FF;
                    font-style: normal;
                    font-size: 20px;
                }
            }
        }
    }
    .scheduleList{
        height: calc(100% - 115px);
        overflow: hidden;
        clear: both;
        margin-top: .5vw;
        .scheduleItem{
            float: left;
            width: calc(50% - .2vw);
            height: 12vw;
            text-align: center;
            margin-bottom: .4vw;
            &:nth-child(even){
                margin-left: .2vw;
            }
            &:nth-child(odd){
                margin-right: .2vw;
            }
            .gameTitle{
                height: 3vw;
                line-height: 3vw;
                background-image: url("../assets/img/updateImg/game_head.png");
                background-size: 100% 100%;
                position: relative;
                .matchType{
                    font-size: 28px;
                    background: linear-gradient(180deg, #FFFFFF 0%, #CAC9C9 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    position: absolute;
                    left: 1vw;
                }
                .date{
                    opacity: .8;
                    color: #fff;
                    font-size: 26px;
                    padding-left: 1vw;
                }
                .address{
                    position: absolute;
                    right: 1vw;
                    color: rgba(255, 255, 255, .57);
                    font-size: 20px;
                }
            }
            .cardBg{
                height: calc(100% - 3vw);
            }
            .leftImg,.middle,.rightImg{
                float: left;
                width: 33.333%;
            }
            .leftImg,.rightImg{
                margin-top: 1.5vw;
                img{
                    width: 30%;
                }
                span{
                    padding-left: 1vw;
                    padding-right: 1vw;
                    font-size: 20px;
                    display: block;
                    color: #fff;
                    margin-top: .5vw;
                }
            }
            .middle{
                color: #fff;
                margin-top: 2vw;
                .vsTit{
                    font-size: 46px;
                }
                .gameState{
                    padding-left: 1vw;
                    font-size: 20px;
                }
            }
        }
    }
</style>
